import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import FullscreenDialog from 'Components/UI/FullscreenDialog';
import { openModal } from 'Helpers/ModalHelper';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import DialogContainer from './DialogContainer';

const styles = () => ({
  root: {},
  dialogPaper: {},
});

const BulkCommunicationSummaryDialog = ({
  classes,
  isOpen,
  ...rest
}) => {
  const { rootNodeProps } = useEventTrackingLogEvent({
    nodeName: 'Bulk Communication Summary',
    isPageView: true,
  });

  return (
    <FullscreenDialog
      className={classes.root}
      title="Bulk Communication Summary"
      variant="white"
      test="bulk-communication-summary-modal"
      hasBackButton
      CloseButtonProps={{
        test: 'bulk-communication-summary-close-modal-button',
      }}
      onClose={() => {
        openModal(['bulkCommunication']);
      }}
      {...rootNodeProps}
    >
      <DialogContainer
        {...rest}
      />
    </FullscreenDialog>
  );
};

BulkCommunicationSummaryDialog.defaultProps = {
  isOpen: true,
};

BulkCommunicationSummaryDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  isOpen: PropTypes.bool,
  onSuccess: PropTypes.func.isRequired,
};

export default withStyles(styles)(BulkCommunicationSummaryDialog);
